import React, { useState } from "react";
import TabNav from "../../../components/TabNav";
import MainLayout from "../../../layouts/MainLayout";
import IncidentInformationTab from "./IncidentRegistration";
import "./incidentRegister.css";
import { CrimeReference } from "types";
import { useLocation } from "react-router-dom";

const tabs = ["Incident Information"];

type Props = {
  incident?: CrimeReference;
};

const IncidentRegister: React.FC<Props> = ({ incident }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { state } = useLocation();

  return incident ? (
    <IncidentInformationTab incident={incident} file={state?.file || null} />
  ) : (
    <MainLayout>
      <div className="incidentRegistration max-w-screen-lg">
        <div className="incident-title">
          <span className="text-2xl font-semibold text-gray-700">
            ⚖ Incident Registration
          </span>
        </div>

        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        <IncidentInformationTab
          incident={incident}
          file={state?.file || null}
        />
      </div>
    </MainLayout>
  );
};

export default IncidentRegister;
